<div>
  <ion-card class="program-missing-card">
    <ion-card-header>
      <ion-card-title>
        {{(toolService.content | async)?.program?.components?.notfound?.cardtitle}}
      </ion-card-title>
      <ion-card-subtitle>
        {{(toolService.content | async)?.program?.components?.notfound?.cardsubtitle}}
      </ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      {{(toolService.content | async)?.program?.components?.notfound?.cardcontent}}
    </ion-card-content>
    <ion-card-content>
      <ion-button class="ion-text-wrap call-to-action-btn" type="button" expand="block" fill="clear" size="large"
        (click)="search()">{{(toolService.content | async)?.basic?.button?.searchall}}
      </ion-button>
    </ion-card-content>
    <ion-card-content>
      <ion-card-content>
        <ion-img class="missing-img" src="assets/svg/missing.svg"></ion-img>
      </ion-card-content>
    </ion-card-content>
  </ion-card>
</div>